<template>
    <div class="start-upload-wrapper">
        <button v-if="!isUploading" class="widget-btn start-upload-btn" @click.prevent="startUpload" :disabled="false">Start Upload ({{filesCount}})</button>
        <button v-else class="widget-btn start-upload-btn" :disabled="true">Uploading {{filesCount}} {{filesCount == 1 ? "file" : "files"}}</button>
    </div>
</template>

<script>
    export default {
        props: ["filesCount", "isUploading", "bus"],
        methods: {
            startUpload: function(e) {
                this.bus.emit("startUpload");
            }
        }
    }
</script>